import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { withTranslation } from '../../../Translator';
import Button from '../../../Button';
import FormContext from '../../../../utils/hoc/formHelpers/context';
import Tooltip from '../../../Tooltip';

class Submit extends React.PureComponent {
  static defaultProps = {
    allowCleanSubmit: false,
  }

  static contextType = FormContext;

  render() {
    const { t, text, disabled, disabledOverride, allowCleanSubmit } = this.props;
    const { dirty, isValid, isSubmitting, errors, id } = this.context;

    const enabled = (() => {
      if (typeof disabledOverride === 'boolean') {
        return !disabledOverride;
      }

      return (dirty || allowCleanSubmit)
        && isValid
        && !isSubmitting
        && !disabled;
    })();
    let tooltipText;

    if (!enabled) {
      if (!isEmpty(errors)) {
        tooltipText = t('Form.submit.button.invalid-form.tooltip');
      } else if (!dirty) {
        tooltipText = t('Form.submit.button.no-changes-in-form.tooltip');
      }
    }

    return (
      // dummy wrapper to narrow tooltips 100% width (what breaks button positions in modal)
      <div>
        <Tooltip content={tooltipText}>
          <Button
            appearance="primary"
            type="submit"
            text={text || t('ok')}
            pending={isSubmitting}
            disabled={!enabled}
            form={id}
            {...this.props}
          />
        </Tooltip>
      </div>
    );
  }
}

export default withTranslation('components')(Submit);
